import { selectCategory } from "@/store/slices/category";
import React from "react";
import { useSelector } from "react-redux";

const PaginationCounterWizzy = () => {
  const categoryState = useSelector(selectCategory);
  if (categoryState.products?.result?.length) {
    return (
      <>
        Showing 1 - {categoryState.products?.result?.length} of{" "}
        {categoryState.products?.total}
      </>
    );
  }
  return <></>;
};

export default PaginationCounterWizzy;
